// extracted by mini-css-extract-plugin
module.exports = {"checkboxInput":"CheckboxRemove_checkboxInput__1dgBz","checkboxLabel":"CheckboxRemove_checkboxLabel__26507"};